<template>
  <div v-if="airline.params.show_fake_card_on_mobile" class="virtual-card-wrap">
    <div class="card-container">
      <div class="card-common front-card">
        <div class="section-top">
          <div class="type-card">
            <div class="type-card-text">
              <h4>{{ lang.vcc.SFS_LANG_ROW_10 }}</h4>
              <h4>
                Valid for: <strong>{{ valid }}</strong>
              </h4>
              <h4 v-if="amount">Value: EUR {{ amount }}</h4>
            </div>
          </div>
          <div v-if="airline && airline.template_config && airline.template_config.logo_creditcard_mobile" style="flex: 1">
            <img style="width: 150px" :src="airline.template_config.logo_creditcard_mobile" />
          </div>
          <div v-else class="logo-card"></div>
        </div>
        <div class="container-row card-pan">1184 5794 3984 7411</div>
        <div class="section-date-thru">
          <div class="type-card"></div>
          <div class="date-valid-thru">
            <div class="content">
              <div class="in-left">
                <h4>VALID</h4>
                <h4>THRU</h4>
              </div>
              <div class="in-right">
                <i class="fas fa-caret-right"></i>
                <h4>MM/YYYY</h4>
                <div class="container-row card-exp">{{ moment().add(6, 'M').format('MM/YYYY') }}</div>
              </div>
            </div>
          </div>
          <div class="type-card">
            {{ lang.vcc.SFS_LANG_ROW_11 }}
          </div>
        </div>
        <div v-if="airline && airline.template_config && airline.template_config.logo_visa_card" class="section-logo-card-type">
          <img :src="airline.template_config.logo_visa_card" />
        </div>
        <div v-else class="section-logo-card-type">
          <img src="@/assets/images/master-card.png" />
        </div>
      </div>
    </div>
    <div class="card-container">
      <div class="card-common back-card">
        <div class="magnetic-strip"></div>
        <div class="signature">
          <div class="cvc-code">
            <div class="code-number-wrap">
              <div class="container-row card-cvv">533</div>
            </div>
            <div class="cvc-text">
              <span>CVC Code</span>
            </div>
          </div>
        </div>
        <div v-if="airline && airline.template_config && airline.template_config.logo_visa_card" class="section-logo-card-type">
          <img :src="airline.template_config.logo_visa_card" />
        </div>
        <div v-else class="section-logo-card-type">
          <img src="@/assets/images/master-card.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@/assets/scss/modules/CreditCard.scss'
export default {
  name: 'MasterCard',
  props: {
    valid: {
      type: String,
      default: ''
    },
    amount: {
      type: [String, Number],
      default: 0
    }
  }
}
</script>
